import * as constants from '../../../../constants';

export const getLinkActionBannerPromo = ({
  bannerPromoKey,
  bannerPromoConfig,
}) => {
  const { action } = bannerPromoConfig[bannerPromoKey] || {};
  if (typeof action !== 'undefined') {
    return `/${constants.GetRegion()}/${action}`;
  }
  return null;
};

export const getLinkActionPurchase = ({ userType }) => {
  if (userType === constants.ANONYMOUS_USER) {
    return `/${constants.GetRegion()}/landing`;
  }
  return `/${constants.GetRegion()}/payment`;
};

export const getSrcBannersPromo = (asset, bannerPromo) => ({
  landscape: asset[`${bannerPromo}_landscape`],
  portrait: asset[`${bannerPromo}_portrait`],
});

export const dateParse = date => {
  date = date.split(' ');
  if (date.length != 2) {
    return null;
  }
  let onlyDate = date[0];
  let onlyTime = date[1];

  onlyDate = onlyDate.split('/');
  onlyTime = onlyTime.split(':');

  if (onlyDate.length != 3 || onlyTime.length != 3) {
    return null;
  }
  return new Date(
    onlyDate[2],
    onlyDate[1] - 1,
    onlyDate[0],
    onlyTime[0],
    onlyTime[1],
    onlyTime[2],
  );
};

export const extractAction = (desc, provider) => {
  if (desc.indexOf('nsual') != -1) return 'contrata Mensual';
  if (desc.indexOf('emanal') != -1) {
    return 'contrata Semanal';
  }
  return `contrata ${provider}`;
};

export const validateSerie = serie => {
  const s = serie;

  const isSerie = med => !!med.serie;
  const media = ext => (ext.media ? isSerie(ext.media) : false);

  return s && s.extendedcommon ? media(s.extendedcommon) : false;
};
